import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IAccess } from '../_models/access.interface';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as moment from 'moment';

@Injectable()
export class AccessConfig {
    static access: IAccess;

    constructor(private http: HttpClient) 
    {

    }

    getAllAccessDetails(): Observable<any> {
      const jsonFile = 'assets/config/access.json?v='+moment(new Date()).format('YYYYMMDDHHmm');    
         return this.http.get(jsonFile)
          .pipe(map(res => res)             
          );
      }
  } 